import style from './ErrorContent.module.css';
/* import PropTypes from 'prop-types'; */

export const ErrorContent = () => {
  console.log(style);
  return (
    <div>404</div>
  );
};
